export default "__VITE_ASSET__uu4UFfkR__"